/**
 * The Symagic Server SpendTime entity.
 * @author Tom Verschoore de la Houssaije
 */
import * as moment from 'moment';
/**
 * The Symagic Server SpendTime entity.
 */
var WorkSlipSpendTime = /** @class */ (function () {
    function WorkSlipSpendTime() {
    }
    Object.defineProperty(WorkSlipSpendTime.prototype, "Effort", {
        get: function () {
            return moment.duration(this.hoursEffort, 'hours').toISOString();
        },
        set: function (value) {
            this.hoursEffort = moment.duration(value).asHours();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkSlipSpendTime.prototype, "TravelTime", {
        get: function () {
            return moment.duration(this.hoursTravelTime, 'hours').toISOString();
        },
        set: function (value) {
            this.hoursTravelTime = moment.duration(value).asHours();
        },
        enumerable: true,
        configurable: true
    });
    return WorkSlipSpendTime;
}());
export { WorkSlipSpendTime };
